import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';

const COR_SETOR = {
  'Atendimento':    '#00c9db',
  'Arte Finalista': '#a78bfa',
  'Pré Produção':   '#fbbf24',
  'Impressão':      '#4f8ef7',
  'Acabamento':     '#4ade80',
  'Corte':          '#f97316',
  'Expedição':      '#34d399',
  'Retirado':       '#2dd4bf',
};

export default function Relatorios() {
  const [dados, setDados]                   = useState(null);
  const [bipagens, setBipagens]             = useState(null);
  const [diaSelecionado, setDiaSelecionado] = useState(null);
  const [buscaTrans, setBuscaTrans]         = useState('');
  const [filtroAcao, setFiltroAcao]         = useState('todas');
  const [carregando, setCarregando]         = useState(true);
  const [carregandoBip, setCarregandoBip]   = useState(false);
  const [erro, setErro]                     = useState('');
  const navigate = useNavigate();

  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
  const isAdmin = usuario.perfil === 'admin';

  useEffect(() => {
    api.getRelatorios()
      .then(setDados)
      .catch((err) => setErro(err.message))
      .finally(() => setCarregando(false));

    if (isAdmin) {
      setCarregandoBip(true);
      api.getBipagens()
        .then(setBipagens)
        .catch(() => setBipagens([]))
        .finally(() => setCarregandoBip(false));
    }
  }, [isAdmin]);

  return (
    <div style={{ minHeight: '100vh', background: '#0d0d0d', display: 'flex', flexDirection: 'column' }}>

      {/* Header */}
      <header style={{
        background: '#111', borderBottom: '1px solid #1a1a1a',
        padding: '0 2rem', height: '72px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div style={{
            width: '48px', height: '48px', background: '#f0a500',
            borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <span style={{ fontFamily: "'Bebas Neue', cursive", color: '#0d0d0d', fontSize: '20px' }}>GM</span>
          </div>
          <div>
            <p style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '1.5rem', color: '#e0e0e0', letterSpacing: '0.06em', margin: 0, lineHeight: 1 }}>
              RELATÓRIOS
            </p>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.82rem', color: '#555', margin: 0, marginTop: '3px' }}>
              Visão geral da produção
            </p>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <button
            onClick={() => navigate('/kanban')}
            style={{
              display: 'flex', alignItems: 'center', gap: '7px',
              background: 'transparent', border: '1px solid #2a2a2a', borderRadius: '10px',
              padding: '8px 14px', color: '#888', fontSize: '0.85rem', cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif", transition: 'all 0.15s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#f0a500'; e.currentTarget.style.color = '#f0a500'; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#2a2a2a'; e.currentTarget.style.color = '#888'; }}
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
            </svg>
            Voltar ao Kanban
          </button>
          <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.85rem', color: '#666' }}>{usuario.nome}</span>
        </div>
      </header>

      <main style={{ flex: 1, padding: '2rem', maxWidth: '900px', width: '100%', margin: '0 auto' }}>

        {carregando && (
          <p style={{ color: '#555', fontFamily: "'DM Sans', sans-serif", textAlign: 'center', marginTop: '4rem' }}>
            Carregando dados...
          </p>
        )}

        {erro && (
          <p style={{ color: '#e05555', fontFamily: "'DM Sans', sans-serif", textAlign: 'center', marginTop: '4rem' }}>
            {erro}
          </p>
        )}

        {!carregando && !erro && dados && (
          <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '16px' }}>

            <div style={{ background: '#141414', border: '1px solid #1e1e1e', borderRadius: '12px', padding: '1.5rem' }}>
              <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', color: '#555', margin: 0, marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                Itens concluídos
              </p>
              <p style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '2.8rem', color: '#4ade80', margin: 0, lineHeight: 1 }}>
                {dados.itens_concluidos}
              </p>
              <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.75rem', color: '#444', margin: 0, marginTop: '6px' }}>
                Passaram por todos os setores
              </p>
            </div>

            <div style={{ background: '#141414', border: '1px solid #1e1e1e', borderRadius: '12px', padding: '1.5rem' }}>
              <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', color: '#555', margin: 0, marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                Itens em produção
              </p>
              <p style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '2.8rem', color: '#f0a500', margin: 0, lineHeight: 1 }}>
                {dados.itens_ativos}
              </p>
              <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.75rem', color: '#444', margin: 0, marginTop: '6px' }}>
                Com entrada registrada
              </p>
            </div>

            <div style={{ background: '#141414', border: '1px solid #1e1e1e', borderRadius: '12px', padding: '1.5rem' }}>
              <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', color: '#555', margin: 0, marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                Setores monitorados
              </p>
              <p style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '2.8rem', color: '#4f8ef7', margin: 0, lineHeight: 1 }}>
                {dados.setores}
              </p>
              <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.75rem', color: '#444', margin: 0, marginTop: '6px' }}>
                No fluxo de produção
              </p>
            </div>

            <div style={{
              background: dados.sem_entrada.length > 0 ? 'rgba(224,85,85,0.06)' : '#141414',
              border: `1px solid ${dados.sem_entrada.length > 0 ? 'rgba(224,85,85,0.3)' : '#1e1e1e'}`,
              borderRadius: '12px', padding: '1.5rem',
            }}>
              <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', color: dados.sem_entrada.length > 0 ? 'rgba(224,85,85,0.7)' : '#555', margin: 0, marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                Entradas não registradas
              </p>
              <p style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '2.8rem', color: dados.sem_entrada.length > 0 ? '#e05555' : '#444', margin: 0, lineHeight: 1 }}>
                {dados.sem_entrada.length}
              </p>
              <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.75rem', color: dados.sem_entrada.length > 0 ? 'rgba(224,85,85,0.5)' : '#444', margin: 0, marginTop: '6px' }}>
                {dados.sem_entrada.length > 0 ? 'Itens sem bipagem de entrada' : 'Tudo em dia'}
              </p>
            </div>

          </div>

          {/* Itens por setor */}
          <div style={{ background: '#111', border: '1px solid #1a1a1a', borderRadius: '14px', padding: '1.75rem', marginTop: '2rem' }}>
            <p style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '1.2rem', color: '#c8c8c8', letterSpacing: '0.08em', margin: 0, marginBottom: '1.25rem' }}>
              ITENS POR SETOR
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {dados.por_setor.map(({ setor, total }) => {
                const cor = COR_SETOR[setor] || '#888';
                const max = Math.max(...dados.por_setor.map((s) => s.total), 1);
                return (
                  <div key={setor} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.85rem', color: '#c0c0c0', width: '140px', flexShrink: 0 }}>
                      {setor}
                    </span>
                    <div style={{ flex: 1, background: '#1a1a1a', borderRadius: '6px', height: '10px', overflow: 'hidden' }}>
                      <div style={{
                        width: total > 0 ? `${(total / max) * 100}%` : '0%',
                        height: '100%',
                        background: cor,
                        borderRadius: '6px',
                        transition: 'width 0.6s cubic-bezier(0.22, 1, 0.36, 1)',
                      }} />
                    </div>
                    <span style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '1.1rem', color: total > 0 ? cor : '#333', minWidth: '24px', textAlign: 'right' }}>
                      {total}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Entradas pendentes */}
          <div style={{
            background: '#111',
            border: `1px solid ${dados.sem_entrada.length > 0 ? 'rgba(224,85,85,0.2)' : '#1a1a1a'}`,
            borderRadius: '14px', padding: '1.75rem', marginTop: '2rem',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: dados.sem_entrada.length > 0 ? '0.75rem' : '1.25rem' }}>
              <p style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '1.2rem', color: '#c8c8c8', letterSpacing: '0.08em', margin: 0 }}>
                ENTRADAS PENDENTES
              </p>
              {dados.sem_entrada.length > 0 && (
                <span style={{
                  fontFamily: "'JetBrains Mono', monospace", fontSize: '0.78rem',
                  background: 'rgba(224,85,85,0.1)', color: '#e05555',
                  border: '1px solid rgba(224,85,85,0.3)', borderRadius: '6px',
                  padding: '3px 10px',
                }}>
                  {dados.sem_entrada.length} {dados.sem_entrada.length === 1 ? 'item' : 'itens'}
                </span>
              )}
            </div>

            {dados.sem_entrada.length > 0 && (
              <div style={{
                display: 'flex', alignItems: 'flex-start', gap: '10px',
                background: 'rgba(224,85,85,0.06)', border: '1px solid rgba(224,85,85,0.15)',
                borderRadius: '10px', padding: '12px 14px', marginBottom: '1.25rem',
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#e05555" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: '1px' }}>
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                  <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
                <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.88rem', color: '#e05555', margin: 0, lineHeight: 1.5 }}>
                  {dados.sem_entrada.length === 1
                    ? 'Este item chegou ao setor mas ainda não teve a entrada bipada. Sem o registro, o tempo de produção não está sendo contabilizado e o item pode estar parado sem que ninguém saiba.'
                    : `Estes ${dados.sem_entrada.length} itens chegaram aos seus setores mas ainda não tiveram a entrada bipada. Sem o registro, o tempo de produção não está sendo contabilizado e os itens podem estar parados sem que ninguém saiba.`
                  }
                </p>
              </div>
            )}


            {dados.sem_entrada.length === 0 ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '1rem 0' }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4ade80" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
                <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.9rem', color: '#4ade80', margin: 0 }}>
                  Todos os itens em produção têm entrada registrada
                </p>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {/* Agrupa por setor para facilitar a leitura */}
                {(() => {
                  const porSetor = {};
                  for (const item of dados.sem_entrada) {
                    if (!porSetor[item.setor_atual]) porSetor[item.setor_atual] = [];
                    porSetor[item.setor_atual].push(item);
                  }
                  return Object.entries(porSetor).map(([setor, itens]) => {
                    const cor = COR_SETOR[setor] || '#888';
                    return (
                      <div key={setor} style={{ background: '#141414', border: '1px solid #1e1e1e', borderRadius: '10px', overflow: 'hidden' }}>
                        {/* Cabeçalho do setor */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 14px', borderBottom: '1px solid #1e1e1e' }}>
                          <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: cor, flexShrink: 0, display: 'inline-block' }} />
                          <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.82rem', color: cor, fontWeight: 700 }}>
                            {setor}
                          </span>
                          <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '0.72rem', color: '#444', marginLeft: 'auto' }}>
                            {itens.length} {itens.length === 1 ? 'item' : 'itens'}
                          </span>
                        </div>
                        {/* Lista de itens */}
                        {itens.map((item) => (
                          <div key={item.numero} style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '12px 14px', borderBottom: '1px solid #181818' }}>

                            {/* Badge da O.S — destaque principal */}
                            <div style={{
                              flexShrink: 0, display: 'flex', flexDirection: 'column',
                              alignItems: 'center', justifyContent: 'center',
                              background: 'rgba(240,165,0,0.1)', border: '1px solid rgba(240,165,0,0.3)',
                              borderRadius: '8px', padding: '6px 10px', minWidth: '64px', textAlign: 'center',
                            }}>
                              <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.6rem', color: '#888', textTransform: 'uppercase', letterSpacing: '0.06em', lineHeight: 1, marginBottom: '3px' }}>
                                O.S
                              </span>
                              <span style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '1.25rem', color: '#f0a500', lineHeight: 1, letterSpacing: '0.04em' }}>
                                {item.ordem_numero}
                              </span>
                            </div>

                            {/* Info do item */}
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '3px' }}>
                                <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '0.8rem', color: '#aaa', flexShrink: 0 }}>
                                  {item.numero}
                                </span>
                                <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.88rem', color: '#e0e0e0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                  {item.descricao}
                                </span>
                              </div>
                              <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', color: '#555' }}>
                                {item.cliente}
                              </span>
                            </div>

                            {/* Ícone de alerta */}
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#f0a500" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, opacity: 0.7 }}>
                              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                              <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                            </svg>

                          </div>
                        ))}
                      </div>
                    );
                  });
                })()}
              </div>
            )}
          </div>
          {/* Histórico de bipagens — apenas admin */}
          {isAdmin && (
            <div style={{ background: '#111', border: '1px solid #1a1a1a', borderRadius: '14px', padding: '1.75rem', marginTop: '2rem' }}>

              {/* Cabeçalho */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
                <p style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '1.2rem', color: '#c8c8c8', letterSpacing: '0.08em', margin: 0 }}>
                  HISTÓRICO DE BIPAGENS
                </p>
                <span style={{
                  fontFamily: "'JetBrains Mono', monospace", fontSize: '0.72rem',
                  background: 'rgba(79,142,247,0.1)', color: '#4f8ef7',
                  border: '1px solid rgba(79,142,247,0.25)', borderRadius: '6px', padding: '3px 10px',
                }}>
                  Visível apenas para admin
                </span>
              </div>

              {/* Filtro Entrada / Saída / Todas */}
              <div style={{ display: 'flex', gap: '6px', marginBottom: '1rem' }}>
                {[
                  { valor: 'todas',      label: 'Todas'      },
                  { valor: 'entrada',    label: 'Entrada'    },
                  { valor: 'saida',      label: 'Saída'      },
                  { valor: 'retrocesso', label: 'Retrocesso' },
                ].map(({ valor, label }) => {
                  const ativo = filtroAcao === valor;
                  const cor = valor === 'entrada' ? '#4ade80' : valor === 'saida' ? '#f97316' : valor === 'retrocesso' ? '#a78bfa' : '#f0a500';
                  return (
                    <button
                      key={valor}
                      onClick={() => { setFiltroAcao(valor); setDiaSelecionado(null); }}
                      style={{
                        fontFamily: "'DM Sans', sans-serif", fontSize: '0.82rem', fontWeight: ativo ? 700 : 400,
                        padding: '6px 16px', borderRadius: '8px', cursor: 'pointer',
                        border: ativo ? `1px solid ${cor}` : '1px solid #2a2a2a',
                        background: ativo ? `${cor}18` : 'transparent',
                        color: ativo ? cor : '#555',
                        transition: 'all 0.15s',
                      }}
                    >
                      {label}
                    </button>
                  );
                })}
              </div>

              {/* Campo de busca */}
              <div style={{ position: 'relative', marginBottom: '1.25rem' }}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                  style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                  <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
                <input
                  type="text"
                  placeholder="Buscar por funcionário, item, O.S, cliente ou setor..."
                  value={buscaTrans}
                  onChange={(e) => { setBuscaTrans(e.target.value); setDiaSelecionado(null); }}
                  style={{
                    width: '100%', boxSizing: 'border-box',
                    background: '#141414', border: '1px solid #2a2a2a', borderRadius: '10px',
                    padding: '9px 12px 9px 36px',
                    color: '#e0e0e0', fontSize: '0.88rem', fontFamily: "'DM Sans', sans-serif",
                    outline: 'none', transition: 'border-color 0.15s',
                  }}
                  onFocus={(e) => { e.target.style.borderColor = '#f0a500'; }}
                  onBlur={(e) => { e.target.style.borderColor = '#2a2a2a'; }}
                />
                {buscaTrans && (
                  <button onClick={() => setBuscaTrans('')} style={{
                    position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)',
                    background: 'none', border: 'none', cursor: 'pointer', color: '#555', padding: '4px',
                    display: 'flex', alignItems: 'center',
                  }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                    </svg>
                  </button>
                )}
              </div>

              {carregandoBip && (
                <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.85rem', color: '#555', margin: 0 }}>Carregando...</p>
              )}

              {!carregandoBip && bipagens && bipagens.length === 0 && (
                <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.85rem', color: '#555', margin: 0 }}>Nenhuma bipagem registrada ainda.</p>
              )}

              {!carregandoBip && bipagens && bipagens.length > 0 && (() => {
                const hoje  = new Date().toDateString();
                const ontem = new Date(Date.now() - 86400000).toDateString();
                const termo = buscaTrans.toLowerCase().trim();

                let base = filtroAcao !== 'todas' ? bipagens.filter((b) => b.acao === filtroAcao) : bipagens;
                if (termo) {
                  base = base.filter((t) =>
                    [t.funcionario, t.item_numero, t.descricao, t.ordem_numero, t.cliente, t.setor, t.setor_destino]
                      .some((v) => v && String(v).toLowerCase().includes(termo))
                  );
                }

                const grupos = [];
                let grupoAtual = null;
                for (const t of base) {
                  const data  = new Date(t.quando);
                  const chave = data.toDateString();
                  let label;
                  if (chave === hoje)       label = 'Hoje';
                  else if (chave === ontem) label = 'Ontem';
                  else label = data.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit' });
                  if (!grupoAtual || grupoAtual.chave !== chave) {
                    grupoAtual = { chave, label, itens: [] };
                    grupos.push(grupoAtual);
                  }
                  grupoAtual.itens.push(t);
                }

                if (grupos.length === 0) {
                  return (
                    <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.88rem', color: '#555', margin: 0 }}>
                      Nenhum resultado{termo ? ` para "${buscaTrans}"` : ''}.
                    </p>
                  );
                }

                const chaveSelecionada = diaSelecionado || grupos[0]?.chave;
                const grupoVisivel = grupos.find((g) => g.chave === chaveSelecionada) || grupos[0];

                return (
                  <div>
                    {/* Chips de dia — ocultos durante busca */}
                    {!termo && (
                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '1.25rem' }}>
                        {grupos.map((g) => {
                          const ativo = g.chave === chaveSelecionada;
                          return (
                            <button key={g.chave} onClick={() => setDiaSelecionado(g.chave)} style={{
                              fontFamily: "'DM Sans', sans-serif", fontSize: '0.82rem',
                              padding: '6px 14px', borderRadius: '8px', cursor: 'pointer',
                              border: ativo ? '1px solid #f0a500' : '1px solid #2a2a2a',
                              background: ativo ? 'rgba(240,165,0,0.12)' : 'transparent',
                              color: ativo ? '#f0a500' : '#555', fontWeight: ativo ? 700 : 400,
                              transition: 'all 0.15s',
                            }}>
                              {g.label}
                              <span style={{ marginLeft: '7px', fontFamily: "'JetBrains Mono', monospace", fontSize: '0.7rem', color: ativo ? '#f0a500' : '#333' }}>
                                {g.itens.length}
                              </span>
                            </button>
                          );
                        })}
                      </div>
                    )}

                    <div style={{ display: 'flex', flexDirection: 'column', gap: termo ? '20px' : '6px' }}>
                      {(termo ? grupos : [grupoVisivel]).map((grupo) => (
                        <div key={grupo.chave}>
                          {termo && grupos.length > 1 && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                              <span style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '0.85rem', color: '#f0a500', letterSpacing: '0.06em' }}>{grupo.label}</span>
                              <div style={{ flex: 1, height: '1px', background: '#1e1e1e' }} />
                              <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '0.7rem', color: '#333' }}>{grupo.itens.length}</span>
                            </div>
                          )}
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                            {grupo.itens.map((t, i) => {
                              const corSetor    = COR_SETOR[t.setor]         || '#888';
                              const corDestino  = COR_SETOR[t.setor_destino] || '#555';
                              const horaStr     = new Date(t.quando).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
                              const isEntrada    = t.acao === 'entrada';
                              const isRetrocesso = t.acao === 'retrocesso';
                              const isAdminUser  = t.perfil_usuario === 'admin';
                              const corBadge     = isEntrada ? '#4ade80' : isRetrocesso ? '#a78bfa' : '#f97316';
                              const bgBadge      = isEntrada ? 'rgba(74,222,128,0.1)' : isRetrocesso ? 'rgba(167,139,250,0.1)' : 'rgba(249,115,22,0.1)';
                              const borderBadge  = isEntrada ? 'rgba(74,222,128,0.3)' : isRetrocesso ? 'rgba(167,139,250,0.3)' : 'rgba(249,115,22,0.3)';
                              const labelBadge   = isEntrada ? 'ENTRADA' : isRetrocesso ? 'RETROCESSO' : 'SAÍDA';
                              return (
                                <div key={i} style={{ background: '#141414', border: '1px solid #1e1e1e', borderRadius: '10px', overflow: 'hidden' }}>
                                  {/* Linha principal */}
                                  <div style={{
                                    display: 'grid', gridTemplateColumns: '60px auto 1fr 1fr 1fr',
                                    alignItems: 'center', gap: '12px', padding: '10px 14px',
                                  }}>
                                    {/* Hora */}
                                    <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '0.82rem', color: '#aaa' }}>{horaStr}</span>

                                    {/* Badge Entrada / Saída / Retrocesso */}
                                    <span style={{
                                      fontFamily: "'JetBrains Mono', monospace", fontSize: '0.65rem', fontWeight: 700,
                                      padding: '2px 7px', borderRadius: '5px', whiteSpace: 'nowrap',
                                      color: corBadge, background: bgBadge, border: `1px solid ${borderBadge}`,
                                    }}>
                                      {labelBadge}
                                    </span>

                                    {/* Funcionário */}
                                    <div style={{ overflow: 'hidden' }}>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '3px', minWidth: 0 }}>
                                        <span style={{
                                          fontFamily: "'JetBrains Mono', monospace", fontSize: '0.62rem',
                                          color: isAdminUser ? '#f0a500' : '#a78bfa',
                                          background: isAdminUser ? 'rgba(240,165,0,0.1)' : 'rgba(167,139,250,0.1)',
                                          border: `1px solid ${isAdminUser ? 'rgba(240,165,0,0.3)' : 'rgba(167,139,250,0.3)'}`,
                                          borderRadius: '4px', padding: '1px 5px', flexShrink: 0,
                                        }}>
                                          {isAdminUser ? 'ADMIN' : (t.setor_usuario || '').toUpperCase()}
                                        </span>
                                        <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.82rem', color: '#e0e0e0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>
                                          {t.funcionario}
                                        </span>
                                      </div>
                                      <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '0.7rem', color: '#555', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        O.S {t.ordem_numero} · {t.cliente}
                                      </span>
                                    </div>

                                    {/* Item */}
                                    <div style={{ overflow: 'hidden' }}>
                                      <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '0.78rem', color: '#aaa', display: 'block' }}>{t.item_numero}</span>
                                      <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', color: '#666', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>{t.descricao}</span>
                                    </div>

                                    {/* Setor */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                                      <span style={{
                                        fontFamily: "'DM Sans', sans-serif", fontSize: '0.75rem', fontWeight: 700,
                                        color: corSetor, background: `${corSetor}18`,
                                        border: `1px solid ${corSetor}40`, borderRadius: '5px',
                                        padding: '2px 7px', whiteSpace: 'nowrap',
                                      }}>
                                        {t.setor}
                                      </span>
                                      {(isRetrocesso || !isEntrada) && t.setor_destino && (
                                        <>
                                          {isRetrocesso ? (
                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#a78bfa" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                                              <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
                                            </svg>
                                          ) : (
                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                                              <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
                                            </svg>
                                          )}
                                          <span style={{
                                            fontFamily: "'DM Sans', sans-serif", fontSize: '0.75rem', fontWeight: 700,
                                            color: corDestino, background: `${corDestino}18`,
                                            border: `1px solid ${corDestino}40`, borderRadius: '5px',
                                            padding: '2px 7px', whiteSpace: 'nowrap',
                                          }}>
                                            {t.setor_destino}
                                          </span>
                                        </>
                                      )}
                                      {!isEntrada && !isRetrocesso && !t.setor_destino && (
                                        <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.75rem', color: '#4ade80' }}>Concluído</span>
                                      )}
                                    </div>

                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}
            </div>
          )}
          </>
        )}
      </main>
    </div>
  );
}
